import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'
import moment from 'moment'
import { Voucher } from '~/_shared/models'

// State
export const state = {
  vouchers: [],
  voucher: new Voucher(),
  total: 0
}

// Getters
export const getters = {
  vouchers: state => state.vouchers,
  voucher: state => state.voucher,
  total: state => state.total
}

// Mutations
export const mutations = {
  VOUCHERS (state, data) {
    state.vouchers = data
  },

  VOUCHER (state, data) {
    state.voucher = Object.assign(new Voucher(), data)
  },

  TOTAL (state, data) {
    state.total = data
  }
}

// Actions
export const actions = {
  async fetchAll ({ commit }, filterData) {
    await axios.get(
      laroute.route('vouchers_filter', { companyAbbr: store.getters['auth/company'], ...filterData })
    ).then(res => {
      res.data.data.items.map((voucher) => {
        voucher.created_at = moment(voucher.created_at).format('YYYY-MM-DD')
        voucher.due_date = moment(voucher.due_date).format('YYYY-MM-DD')
      })

      commit('VOUCHERS', res.data.data.items)
      commit('TOTAL', res.data.data.total)
    }).catch(err => {
      console.log(err)
    })
  },

  async fetchOne ({ commit }, id) {
    await axios.get(laroute.route('get_voucher', {
      id
    })).then(res => {
      commit('VOUCHER', res.data.data.data.voucher)
    }).catch(err => {
      throw err
    })
  },

  async createFromPo ({ commit }, data) {
    await axios.post(laroute.route('create_voucher_po', { companyAbbr: store.getters['auth/company'] }), data)
      .then(res => {
        commit('VOUCHER', res.data.data)
      })
      .catch(err => {
        console.log(err)
        throw err
      })
  },

  async createFromBlank ({ commit }, data) {
    await axios.post(laroute.route('create_voucher_blank', { companyAbbr: store.getters['auth/company'] }), data)
      .then(res => {
        commit('VOUCHER', res.data.data)
      })
      .catch(err => {
        console.log(err)
        throw err
      })
  },

  async createItems ({ commit }, { id, items }) {
    await axios.patch(laroute.route('add_item_voucher', { id }), { items })
  },

  async update ({ commit }, { id, voucher, items }) {
    await axios.patch(laroute.route('update_voucher', { id }), { voucher, items })
  },

  async localVoucherUpdate ({ commit }, voucher) {
    console.log('actions', voucher)
    commit('VOUCHER', voucher)
  },

  async delete ({ commit }, { id, reason }) {
    await axios.delete(laroute.route('delete_voucher', { id }), { data: { reason } })
  },

  async deleteItem ({ commit }, { id }) {
    await axios.delete(laroute.route('delete_voucher_item', { id }))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/voucher.js